export interface Gender {
    value: string;
    valueText: string;
}
  
export const GENDERS: Gender[] = [{
    value: 'male',
    valueText: 'Male'
},{
    value: 'female',
    valueText: 'Female'
},{
    value: 'other',
    valueText: 'Other'
}];
  